import React from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Compact highlight card (o.a. vragenlijst-intro).
 * `item.iconTileClass` optioneel — default accent-tile.
 */
export default function RPCardOne({ item }) {
  const Icon = item.icon;
  const tileClass =
    item.iconTileClass ||
    "bg-wa-panel text-wa-accent ring-1 ring-inset ring-wa-border/70";

  return (
    <li className="group flex min-h-[5.5rem] overflow-hidden rounded-xl border border-wa-border bg-wa-panel2/50 shadow-sm transition duration-200 hover:border-wa-accent/40 hover:shadow-md">
      <div
        className={classNames(
          "flex w-14 shrink-0 items-center justify-center sm:w-16",
          tileClass
        )}
      >
        {Icon ? <Icon className="h-7 w-7 shrink-0" aria-hidden="true" /> : null}
      </div>
      <div className="flex min-w-0 flex-1 flex-col justify-center border-l border-wa-border/60 bg-wa-panel/40 px-3 py-3 sm:px-4">
        <p className="text-sm font-semibold leading-snug text-wa-text">{item.title}</p>
        {item.subtitle ? (
          <p className="mt-1 line-clamp-2 text-xs text-wa-muted">{item.subtitle}</p>
        ) : null}
      </div>
    </li>
  );
}
